var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasStats)?_c('div',{staticClass:"re-shop-products-filters"},[_c('re-page-mashup',_vm._g(_vm._b({attrs:{"eventspace":_vm.eventSpace},model:{value:(_vm.fields),callback:function ($$v) {_vm.fields=$$v},expression:"fields"}},'re-page-mashup',_vm.pageBuilderAttr,false),_vm.builderListeners))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }